import { render, staticRenderFns } from "./ResidentMultipleRegisterExampleModal.vue?vue&type=template&id=786cd72a&lang=pug"
import script from "./ResidentMultipleRegisterExampleModal.vue?vue&type=script&lang=ts"
export * from "./ResidentMultipleRegisterExampleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports